import { render, staticRenderFns } from "./ChartWizard.vue?vue&type=template&id=4a78989d&scoped=true"
import script from "./ChartWizard.vue?vue&type=script&lang=js"
export * from "./ChartWizard.vue?vue&type=script&lang=js"
import style1 from "./ChartWizard.vue?vue&type=style&index=1&id=4a78989d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a78989d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a78989d')) {
      api.createRecord('4a78989d', component.options)
    } else {
      api.reload('4a78989d', component.options)
    }
    module.hot.accept("./ChartWizard.vue?vue&type=template&id=4a78989d&scoped=true", function () {
      api.rerender('4a78989d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceWatcher/ChartWizard.vue"
export default component.exports